import {useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {ArrowLeft, Envelope, UserCircle} from '@phosphor-icons/react';
import {Field} from '@/components/ui/Field';
import {TenantFooter} from '@/components/layout/TenantFooter';
import {TenantHeader} from '@/components/layout/TenantHeader';
import {ownerPath, tenantPath} from '@/lib/tenant/resolve';

/** Профиль клиента: вход по ссылке на почту, без пароля. */
export function ProfilePage() {
  const {slug = ''} = useParams();
  const [email, setEmail] = useState('');
  const [linkSent, setLinkSent] = useState(false);

  return (
    <div className="flex min-h-[calc(100dvh-6rem)] flex-1 flex-col">
      <TenantHeader />
      <div className="stagger flex flex-col gap-6 px-4 pb-8 pt-6">
        <Link to={tenantPath(slug)} className="flex items-center gap-2 text-[14px] text-muted-foreground">
          <ArrowLeft size={20} aria-hidden />
          На главную
        </Link>

        <div className="panel flex flex-col gap-5 rounded-[32px] p-6">
          <span className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-foreground">
            <UserCircle size={34} weight="regular" aria-hidden />
          </span>
          <h1 className="m-0 text-[32px] font-bold leading-[1.05] tracking-tight text-foreground">Профиль клиента</h1>
          <p className="m-0 text-[16px] leading-relaxed text-muted-foreground">
            Сохраняйте новые записи в одном месте и открывайте их с любого устройства.
          </p>
          <Field label="Почта" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
          <span className="text-[15px] leading-snug text-muted-foreground">Пароль не нужен. Отправим ссылку для входа.</span>
          <button
            type="button"
            disabled={linkSent}
            onClick={() => setLinkSent(true)}
            className="btn-accent rounded-full px-6 py-3.5 text-[16px] font-semibold disabled:opacity-60"
          >
            {linkSent ? 'Ссылка отправлена' : 'Получить ссылку'}
          </button>
        </div>

        <div className="flex items-center gap-3 text-[15px] text-muted-foreground">
          <Envelope size={20} aria-hidden />
          <span>
            Вы владелец студии?{' '}
            <Link to={ownerPath(slug, 'login')} className="font-semibold text-foreground underline underline-offset-4">
              Открыть кабинет студии
            </Link>
          </span>
        </div>
      </div>
      <TenantFooter />
    </div>
  );
}
